import { render, staticRenderFns } from "./PermissionAdd.vue?vue&type=template&id=5e45946a&scoped=true&"
import script from "./PermissionAdd.vue?vue&type=script&lang=js&"
export * from "./PermissionAdd.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5e45946a",
  null
  
)

export default component.exports